import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { HomeComponent } from './app/home/home.component';
import { PrivacypoliciesComponent } from './app/privacypolicies/privacypolicies.component';
import { NotFoundComponent } from './app/404/not-found.component';
import { ApidocumentationComponent } from './app/apidocumentation/apidocumentation.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';

if (environment.production) {
  enableProdMode();
}

const routes = [
  { path: '', component: HomeComponent },
  { path: 'privacypolicies', component: PrivacypoliciesComponent },
  { path: '404', component: NotFoundComponent },
  { path: 'apidocumentation', component: ApidocumentationComponent },
  { path: '**', redirectTo: '404' },
];

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideHttpClient(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      })
    ),
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: { prefix: '/assets/i18n/', suffix: '.json' },
    },
    importProvidersFrom(
      TranslateModule.forRoot({
        fallbackLang: 'en',
        loader: {
          provide: TranslateLoader,
          useClass: TranslateHttpLoader,
        },
      })
    ),
  ],
});
